export default "__VITE_ASSET__yW1KK2ld__"